import axios from 'axios';
import { api } from '../../config';
import { get as storageGet, remove as storageRemove } from '../local-storage-service';

export class ApiResponse {
  public status: number;
  public data: any;
  public headers?: any;

  public isSuccess: boolean;
  public isError: boolean;

  constructor(status: number, data: any, headers?: any) {
    this.status = status;
    this.data = data;
    this.headers = headers;

    this.isSuccess = status >= 200 && status <= 299;
    this.isError = !this.isSuccess;
  }

  public get(x: string) {
    return this.data[x];
  }

  public getErrorList() {
    return this.data.errors.map((errorData: any) => {
      return errorData.msg;
    });
  }

  public getError() {
    return this.getErrorList().join(' ');
  }

  public isServerError() {
    return this.status >= 500 && this.status < 600;
  }
}

export const request = (options: any): Promise<ApiResponse> => {
  const headers: any = {
    Accept: 'application/json',
    ...options.headers,
  };

  const accessToken = storageGet('accessToken');

  if (accessToken) {
    headers.Authorization = `JWT ${accessToken}`;
  }

  return axios
    .request({
      baseURL: api.endpoint,
      responseType: 'json',
      ...options,
      headers,
    })
    .then(function(response) {
      const { status, data } = response;

      return new ApiResponse(status, data, response.headers);
    })
    .catch(function(error) {
      if (error.response) {
        const { status, data } = error.response;

        if (status == 401) {
          storageRemove('accessToken');
          window.location.href = '/login';
        }

        return new ApiResponse(status, data);
      }
      return new ApiResponse(400, {});
    });
};
